var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-10 -10 140 140",
    style: {
      enableBackground: "new 0 0 118.08 122.75"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.all{vector-effect:non-scaling-stroke;fill:#CF424B;stroke:#CF424B;stroke-linecap:round;stroke-miterlimit:10;stroke-width:6}\n\t.st0{fill:#FFFFFF;stroke:none}\n\t.st1{stroke-width:6;fill:none}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "all st0",
    cx: 59.06,
    cy: 63.57,
    r: 56.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "all st1 icon_status",
    d: "M88.23,15.7c16.1,9.86,26.85,27.63,26.85,47.92c0,31-25.09,56.13-56.04,56.13S3,94.62,3,63.62 c0-19.37,9.8-36.45,24.71-46.54"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "all st2 icon_status",
    cx: 57.68,
    cy: 83.75,
    rx: 3.21,
    ry: 3.12
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "all st3 icon_status",
    points: "58.01,59.63 56.83,59.63 55.98,4.5 58.85,4.5 "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExc);
export default __webpack_public_path__ + "static/media/Exc.5d12c98271debf03013622254f2af870.svg";
export { ForwardRef as ReactComponent };